import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../shared/auth/auth-guard.service';
import { OrderdetailsComponent } from './orderdetails.component';



const routes: Routes = [
  {
    path: '',
     component: OrderdetailsComponent,
    data: {
      title: 'orderlist'
    },    
    canActivate: [AuthGuard] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderDetailsRoutingModule { }